



































import Vue from 'vue';
import Component from 'vue-class-component';
import CAppHeader from './components/CAppHeader.vue';
import CAppFooter from './components/CAppFooter.vue';


@Component({
  components: {
    CAppHeader,
    CAppFooter,
  },
})
export default class App extends Vue {}
